import { render, staticRenderFns } from "./AdminAccessRequest.vue?vue&type=template&id=294e11d4&scoped=true"
import script from "./AdminAccessRequest.vue?vue&type=script&lang=js"
export * from "./AdminAccessRequest.vue?vue&type=script&lang=js"
import style0 from "./AdminAccessRequest.vue?vue&type=style&index=0&id=294e11d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e11d4",
  null
  
)

export default component.exports